// =============================================================
// SINGLE SOURCE OF TRUTH for which network the DEX runs on.
// Change ACTIVE_NETWORK_KEY to flip environments. Never shown to users.
//   "opbnbMainnet" -> production    "opbnbTest" -> internal testing
// =============================================================

import { NETWORKS } from "./networks";
import { CONTRACTS } from "./contracts";

// 🔧 CHOOSE THE NETWORK HERE (in code only):
export const ACTIVE_NETWORK_KEY = "opbnbMainnet";

export const ACTIVE_NETWORK = NETWORKS[ACTIVE_NETWORK_KEY];
export const ACTIVE_CONTRACTS = CONTRACTS[ACTIVE_NETWORK_KEY];

export const USDT_DECIMALS = 18;
export const SCN_DECIMALS = 18;

// Sell fee charged by the SCN contract (10%); used for display only.
export const SELL_FEE_PCT = 10;

// Default slippage tolerance (%).
export const DEFAULT_SLIPPAGE = 1;

// How often (ms) balances/price are re-read. Polling, not callbacks.
export const POLL_INTERVAL_MS = 12000;

// Debounce (ms) for the live quote as the user types.
export const QUOTE_DEBOUNCE_MS = 350;

export const APP_NAME = "Smartcore DEX";
